import { Message } from 'semantic-ui-react';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { TitledCard } from 'Components/';

import StudentBulkImportLoading from '../LoadingComponents/StudentBulkImportLoading';

export class VendorLinkBulkImport extends Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    isComplete: PropTypes.bool.isRequired,
  };

  render() {
    const { loading, isComplete } = this.props;

    return (
      <TitledCard title={'Manual Import'}>
        {!isComplete && !loading && (
          <Message info>
            <Message.Header>{'Manual Import'}</Message.Header>
            <Message.Content>
              {'This will start importing your students by mapping their ' +
                'data according to the mapping configuration you chose. ' +
                'It may take a few minutes.'}
            </Message.Content>
          </Message>
        )}
        {loading && !isComplete && <StudentBulkImportLoading />}
        {isComplete && !loading && (
          <Message info>
            <Message.Header>{'Manual Import has finished'}</Message.Header>
          </Message>
        )}
      </TitledCard>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/vendorlinkintegration/components/VendorLinkImportStep/VendorLinkBulkImport.js